// extracted by mini-css-extract-plugin
export default {"closeBtn":"error_closeBtn__7L35i","errorPopup":"error_errorPopup__pRSte"};